import React from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { compose } from 'react-apollo';
import s from './SeeAll.css';
import cs from '../../../components/commonStyle.css';
// Removed react-bootstrap Button - using native button
import cx from 'classnames';
import { FormattedMessage, injectIntl } from 'react-intl';
import messages from '../../../locale/messages';
import history from '../../../core/history';
import { getActiveCategory } from '../../../reducers/category';
//
import arrowIcon from '/public/SiteIcons/viewAllArrow.svg';

class SeeAll extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    const { activeCategory } = this.props;
    const categoryParam = activeCategory && activeCategory !== 'boat' ? `?categoryType=${activeCategory}` : '';
    history.push(`/s${categoryParam}`);
  }

  render() {
    return (
      <div className={cx(s.seeAllContainer)}>
        <button type="button" className={cx(s.seeAllBtnnew)} onClick={() => this.handleClick()}>
          <span><FormattedMessage {...messages.viewAllText} /></span>
          <img src={arrowIcon} className={s.seeAllArrow} alt="" />
        </button>
      </div>
    );
  }
}

const mapState = (state) => ({
  activeCategory: getActiveCategory(state)
});

export default compose(
  injectIntl,
  connect(mapState),
  withStyles(s, cs)
)(SeeAll);